/**
 * Device-settings modal navigation helpers.
 *
 * Deep-links (Calibrate CTA → Behavior) race two Svelte reactives:
 * 1. Nav tree rebuilds when settings load and only marks the parent category
 *    active, so a leaf like `trv_behaviour` disappears and the pane falls back
 *    to Details.
 * 2. `isMobile` starts false, then ModalContentLayout binds true (window width
 *    is 0 until `svelte:window` hydrates). `hideRightContent = isMobile` then
 *    hides the target screen after it already mounted.
 */

export function getSettingsNavGenerateTab(options: {
	initialize: boolean;
	firstCategoryTitle?: string;
	cachedTitle?: string;
	activeItemTitle?: string;
}): string | undefined {
	if (options.initialize) return options.firstCategoryTitle;
	return options.cachedTitle || options.activeItemTitle || options.firstCategoryTitle;
}

/**
 * Parent categories (`settings`) and folded leaves (`trv_behaviour`) both need
 * to light up when `tab` is the leaf title from a deep-link.
 */
export function isSettingsNavTabMatch(
	tab: string | undefined,
	itemTitle: string,
	childTitles: readonly string[] = [],
): boolean {
	if (!tab) return false;
	return itemTitle === tab || childTitles.includes(tab);
}

export function getSettingsModalPaneFlags(options: { isMobile: boolean; drillIntoSetting: boolean }): {
	hideLeftContent: boolean;
	hideRightContent: boolean;
} {
	if (!options.isMobile) {
		return { hideLeftContent: false, hideRightContent: false };
	}
	if (options.drillIntoSetting) {
		return { hideLeftContent: true, hideRightContent: false };
	}
	return { hideLeftContent: false, hideRightContent: true };
}
